import React from "react";
import auth0Config from "../utils/auth0ConfigHelper";
import LoginContainerCSR from "./LoginContainerCSR";
import LoginContainerCustomer from "./LoginContainerCustomer";

const AppContent: React.FC = () => {
  if (auth0Config?.dict.signin.title === "delegated-admin-app") {
    return <LoginContainerCSR />;
  }

  return <LoginContainerCustomer />;
};
export default AppContent;
